import React, {useState} from 'react';
import './AbonneForm.css';
import {
    validateAdminPersonalInfo,
    validateAdminIdentificationInfo,
  } from '../../utils/validation';
import { initialAdminFormData } from '../../utils/formData';

function AdminForm() {
    const [currentStep, setCurrentStep] = useState(1);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(initialAdminFormData);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };

    const validateFields = () => {
        let newErrors = {};
      
        if (currentStep === 1) {
          newErrors = validateAdminPersonalInfo(formData);
        }
      
        if (currentStep === 2) {
          newErrors = validateAdminIdentificationInfo(formData);
        }
      
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
      
      const handleNext = () => {
        if (validateFields()) {
          setCurrentStep(currentStep + 1);
        }
      };
      
      const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFields()) {
          alert('Formulaire envoyé avec succès');
        }
      };
    
    const handleBack = () => {
        setCurrentStep(currentStep - 1);
    };
    
    
  return (
    <div className="inscrip-container">
      <form onSubmit={handleSubmit} className='inscription-form'>
        {currentStep === 1 && (
          <div className="form-step">
            <h2 className='inscription-title'>Informations personnelles administrateur</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Prénom</label>
                    <input type="text" name="prenom" value={formData.prenom} onChange={handleChange} placeholder="Entrez le prénom" />
                    {errors.prenom && <span className="error">{errors.prenom}</span>}
                </div>
                <div className="form-group">
                    <label>Nom</label>
                    <input type="text" name="nom" value={formData.nom} onChange={handleChange} placeholder="Entrez le nom" />
                    {errors.nom && <span className="error">{errors.nom}</span>}
                </div>
                <div className="form-group">
                    <label>Résidence</label>
                    <input type="text" name="residence" placeholder="Entrez la Résidence" alue={formData.residence} onChange={handleChange} />
                    {errors.residence && <span className="error">{errors.residence}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Entrez l'email" required />
                    {errors.email && <span className="error">{errors.email}</span>}
                </div>
                <div className="form-group">
                    <label>Numéro de téléphone</label>
                    <input type="tel" name="telephone" value={formData.telephone} onChange={handleChange} placeholder="+223 ..." />
                    {errors.telephone && <span className="error">{errors.telephone}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Genre</label>
                    <select name="genre" value={formData.genre} onChange={handleChange}>
                        <option value="">Sélectionnez le Genre</option>
                        <option value="male">Masculin</option>
                        <option value="female">Féminin</option>
                    </select>
                    {errors.genre && <span className="error">{errors.genre}</span>}
                </div>
                <div className="form-group">
                    <label>Date de naissance</label>
                    <input type="date" name="dateNaissance" value={formData.dateNaissance} onChange={handleChange} />
                    {errors.dateNaissance && <span className="error">{errors.dateNaissance}</span>}
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="info-supplementaire">Info supplémentaire</label>
                <textarea id="info-supplementaire" placeholder="Les autres Informations"></textarea>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="form-step">
            <h2 className='inscription-title'>Informations d'identification</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom d'utilisateur</label>
                    <input type="text" name="username" value={formData.username} onChange={handleChange} placeholder="Entrez le nom d'utilisateur" />
                    {errors.username && <span className="error">{errors.username}</span>}
                </div>
                <div className="form-group">
                    <label>Mot de passe</label>
                    <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Entrez le mot de passe" />
                    {errors.password && <span className="error">{errors.password}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Rôle</label>
                    <select name="role" value={formData.role} onChange={handleChange}>
                        <option value="adminp">Administrateur principal</option>
                        <option value="admins">Administrateur secondaire</option>
                    </select>
                    {errors.role && <span className="error">{errors.role}</span>}
                </div>
                <div className="form-group">
                    <label>Permissions</label>
                    <select name="permissions" value={formData.permissions} onChange={handleChange}>
                        <option value="ga">Gestion des abonnés</option>
                        <option value="gs">Gestion des services</option>
                        <option value="cra">Consultation des rapports analytiques.</option>
                    </select>
                    {errors.permissions && <span className="error">{errors.permissions}</span>}
                </div>
            </div>
          </div>
        )}

        <div className="form-navigation">
        {currentStep > 1 && (
            <button type="button" onClick={handleBack} className="back-button">
            Retour
            </button>
        )}
        {currentStep < 2 ? (
            <button type="button" onClick={handleNext} className="next-button">
            Suivant
            </button>
        ) : (
            <button type="submit" className="submit-button">
            Enregistrer
            </button>
        )}
        </div>
      </form>
    </div>
  )
}

export default AdminForm